import { render, staticRenderFns } from "./TooltipContent.vue?vue&type=template&id=37be6961&scoped=true"
import script from "./TooltipContent.vue?vue&type=script&lang=js"
export * from "./TooltipContent.vue?vue&type=script&lang=js"
import style0 from "./TooltipContent.vue?vue&type=style&index=0&id=37be6961&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37be6961",
  null
  
)

export default component.exports